import { Helmet } from 'react-helmet-async';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
// @mui
import {
  Card,
  Stack,
  Button,
  Box,
  Checkbox,
  MenuItem,
  Typography,
  TextField,
  Modal,
  FormControl,
  Select,
  OutlinedInput,
  Divider,
  Tooltip,
  IconButton,
  useMediaQuery,
  FormControlLabel,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'moment/locale/tr';
// components
import Iconify from '../components/iconify';
// sections
import api from 'src/services/BaseService';
import { tokenService } from 'src/services';
import CreateWorkOrderModal from 'src/components/modals/CreateWorkOrderModal';
import DeliveryModal from 'src/components/modals/DeliveryModal';
import AddEditPersonelModal from 'src/components/modals/AddEditPersonelModal';
import './muhaberatOutput.css';
import AddEntityButton from 'src/components/shared/AddEntityButton';
import EditButton from 'src/components/shared/EditButton';
import ClearButton from 'src/components/shared/ClearButton';
import FilterButton from 'src/components/shared/FilterButton';
import ExportToExcelButton from 'src/components/shared/ExportToExcelButton';
import DynamicTable from 'src/components/shared/DynamicTable';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CustomFilter from 'src/components/filter/CustomFilter';
import FilterViewButton from 'src/components/shared/FilterViewButton';
import EditMuhaberatOutputPost from 'src/components/modals/EditMuhaberatOutputPost';
import { Label } from '@mui/icons-material';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// ----------------------------------------------------------------------

const directions = [
  {
    value: 'all',
    label: 'Tümü',
  },
  {
    value: 'MallLogisticsToCustomer',
    label: 'Muhaberattan Müşteriye',
  },
  {
    value: 'CustomerToMallLogistics',
    label: 'Müşteriden Muhaberata',
  },
];

const emailsMap = {
  OF0: 'zc.ofisavm@zorlu.com',
  T2: 'zc.te2lobi@zorlu.com',
  T1: 'zc.te1lobi@zorlu.com',
  R1: 'zc.r1lobi@zorlu.com',
  R2: 'zc.r2lobi@zorlu.com',
  R3: 'zc.r3lobi@zorlu.com',
};

moment.locale('tr');

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 0;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const StatusList = [
  { label: 'Şubede', id: 5 },
  { label: 'Tamamlandı', id: 1 },
];

export default function MuhaberatOutput() {
  const parsedUser = JSON.parse(localStorage.getItem('user'));

  const customer = useSelector((state) => state.customerReducer);
  const [isBackdropOpen, setIsBackdropOpen] = useState(false);
  const [dataLimit, setDataLimit] = useState(2000);
  const [page, setPage] = useState(0);
  const [resetPage, setResetPage] = useState(false);
  const [selected, setSelected] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedDirection, setSelectedDirection] = useState({
    value: 'all',
    label: 'Tümü',
  });
  const [filterName, setFilterName] = useState('');
  const [customerNameLike, setCustomerNameLike] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [originalData, setOriginalData] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedCargoStatus, setSelectedCargoStatus] = useState([]);
  const [locations, setLocations] = useState([]);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [firm, setFirm] = useState('');
  const [barcode, setBarcode] = useState('');
  const [cargo, setCargo] = useState('');
  const [tower, setTower] = useState('');
  const [office, setOffice] = useState('');

  const [handoverModal, setHandoverModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState('');
  const [addPersonelModalOpen, setAddPersonelModalOpen] = useState(false);
  const [showAddPersonelModal, setShowAddPersonelModal] = useState(false);
  const [personelList, setPersonelList] = useState([]);

  const [confirmCode, setConfirmCode] = useState(null);
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [recieverNameLastname, setRecieverNameLastname] = useState('');
  const [open, setOpen] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showPopUpError, setShowPopUpError] = useState(false);

  const [branchTitles, setBranchTitles] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);

  const [deliveredName, setDeliveredName] = useState('');
  const [totalPackageCount, setTotalPackageCount] = useState(0);

  const [selectedPost, setSelectedPost] = useState();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deliveryTimestamp, setDeliveryTimestamp] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const logoBase64 =
    'data:image/png;base64,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';

  const [filterModal, setFilterModal] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  const handleModal = () => {
    setFilterModal(true);
  };

  const handleCloseModal = () => {
    setFilterModal(false);
  };
  //TABLE

  const handleChangeCustomerNameLike = (event) => {
    setCustomerNameLike(event.target.checked);
  };
  const TABLE_HEAD = [
    {
      id: parsedUser.type === 'user' ? 'none' : 'checkbox', // Checkbox sütununun id'si
      label: '', // Başlık boş bırakılabilir
      alignRight: false,
      format: (value, row) => {
        // Checkbox'ı row.status değerine göre göster
        if (row.status === '5' && parsedUser.type !== 'user') {
          return (
            <Checkbox
              checked={selected.indexOf(row.id) !== -1}
              onChange={(e) => handleCheckboxChange(e, row.id, row)}
            />
          );
        }
        return null;
      },
      sx: { width: 50 }, // Genişlik ayarı
    },
    { id: 'no', label: 'No', alignRight: false, sx: { width: 10 } },
    { id: 'barcode', label: 'Barkod', alignRight: false },
    {
      id: 'title',
      label: 'Kişi',
      alignRight: false,
      sortBy: 'dataJSON.customerName',
      format: (value, row) => {
        return row.dataJSON?.customerName;
      },
    },
    { id: 'branchTitle', label: 'Firma', alignRight: false },
    {
      id: 'tower',
      label: 'Kule',
      alignRight: false,
      format: (value, row) => {
        return row.dataJSON?.tower;
      },
      sortBy: 'dataJSON.tower',
    },
    {
      id: 'office',
      label: 'Daire',
      alignRight: false,
      format: (value, row) => {
        return row.dataJSON?.office;
      },
      sortBy: 'dataJSON.office',
    },
    {
      id: 'corporationID',
      label: 'Firma ID',
      alignRight: false,
      format: (value, row) => {
        return row.customer?.corporationID;
      },
      sortBy: 'customer.corporationID',
    },
    {
      id: 'status',
      label: 'Kargo Durumu',
      alignRight: false,
      format: (value, row) => {
        if (row.status === '5') {
          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <span
                style={{
                  backgroundColor: 'rgba(247, 169, 55, 0.36)',
                  padding: '7px',
                  borderRadius: '5px',
                }}
              >
                Şubede
              </span>
            </div>
          );
        } else {
          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <span
                style={{
                  backgroundColor: 'rgba(10, 127, 50, 0.24)',
                  padding: '7px',
                  borderRadius: '5px',
                }}
              >
                Teslim Edildi
              </span>
            </div>
          );
        }
      },
    },
    {
      id: 'orderInventory',
      label: 'Paket Sayısı',
      alignRight: false,
      format: (value, row) => {
        return value;
      },
      sortFunction: (row) => parseInt(row.orderInventory, 10),
    },
    {
      id: 'takenBy',
      label: 'Teslim Alan Kişi',
      alignRight: false,
      format: (value, row) => {
        if (row.handover && row.status === '1') {
          return row.handover?.name + ' ' + row.handover?.lastname;
        } else {
          return '-';
        }
      },
      sortBy: 'handover.name',
    },
    {
      id: 'createdDateTime',
      label: 'Oluşturulma Tarihi',
      alignRight: false,
      format: (value) => moment.unix(value).format('DD/MM/YYYY HH:mm'),
    },
    {
      id: 'deliveredDateTime',
      label: 'Teslim Tarihi',
      alignRight: false,
      format: (value) =>
        value ? moment.unix(value).format('DD/MM/YYYY HH:mm') : '-',
    },
    {
      id: 'shipmentFirm',
      label: 'Kargo Firması',
      sortBy: 'dataJSON.shipmentFirm',
      alignRight: false,
      format: (value, row) => {
        return row.shipmentFirm;
      },
    },
    {
      id: 'operation',
      label: '',
      alignRight: false,
      format: (value, row) => {
        const createdTime = new Date(row.createdDateTime * 1000);
        const currentTime = new Date();
        const timeDifference = currentTime - createdTime;

        const oneDayInMilliseconds = 24 * 60 * 60 * 1000;

        if (row.status === '5' && parsedUser.type !== 'user')
          return (
            <div style={{ gap: '10px', flexDirection: 'row', display: 'flex' }}>
              <EditButton
                tooltip="İşlem"
                icon={'iconoir:delivery'}
                onClick={() => handleOpenDeliveryModal(row.id, row)}
              />

              {timeDifference < oneDayInMilliseconds && (
                <EditButton onClick={() => handleOpenEditModal(row)} />
              )}
            </div>
          );
      },
      sx: { width: 100 },
    },
  ];

  const handleOpenEditModal = (post) => {
    setSelectedPost(post);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setSelectedPost();
    getData();
  };

  useEffect(() => {
    const handleOnlineStatus = () => setIsOnline(navigator.onLine);

    window.addEventListener('online', handleOnlineStatus);
    window.addEventListener('offline', handleOnlineStatus);

    return () => {
      window.removeEventListener('online', handleOnlineStatus);
      window.removeEventListener('offline', handleOnlineStatus);
    };
  }, []);

  useEffect(() => {
    const mallID = localStorage.getItem('mallID');

    if (mallID === '61973122632916808660') {
      setShowAddPersonelModal(true);
    } else {
      setShowAddPersonelModal(false);
    }
  }, [customer]);

  const getFilteredOrderList = () => {
    const isFiltered =
      barcode ||
      cargo ||
      selectedCargoStatus.length > 0 ||
      selectedBranches.length > 0 ||
      startDate ||
      endDate ||
      firm ||
      office ||
      tower ||
      filterName ||
      deliveredName;

    const filters = {
      type: 'post-office',
      direction: ['CustomerToMallLogistics', 'MallLogisticsToCustomer'],
      mallID: customer?.customer?.id,
      status:
        selectedCargoStatus.length > 0
          ? selectedCargoStatus.map((status) => status.id)
          : null,
      barcode: barcode || null,
      shipmentFirm: cargo || null,
      limit: isFiltered ? 1000000 : 2000,
      branchID: selectedBranches,
      tower: tower || null,
      office: office || null,
      startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
      endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
      customerName: filterName || null,
      handoverName: deliveredName || null,
      customerNameLike: customerNameLike,
    };

    let filteredData = [];
    api
      .post('posts/get', filters)
      .then((response) => {
        if (response.data.status) {
          filteredData = response.data.result;

          setOrderList(filteredData);
          setResetPage(true);
        } else {
          toast.error('Filtreleme sonucu bulunamadı.');
          setOrderList([]);
        }
      })
      .catch(() => {
        toast.error('Filtreleme sırasında bir hata oluştu.');
        setOrderList([]);
      });
  };

  const clearFilters = () => {
    setOrderList(originalData);
    setBarcode('');
    setFirm('');
    setCargo('');
    setTower('');
    setOffice('');
    setSelectedCargoStatus([]);
    setSelectedDirection({ value: 'all', label: 'Tümü' });
    setStartDate(null);
    setEndDate(null);
    setFilterName('');
    setDeliveredName('');
    setSelectedBranches([]);
    setResetPage(false);
  };

  const sendMail = (items, pdfLink, excelLink, emailTo) => {
    if (!emailTo || !deliveryTimestamp) return;

    const formattedDate = deliveryTimestamp.format('D MMMM YYYY HH:mm');
    const inventoryCount = items
      .reduce((sum, item) => sum + parseInt(item.orderInventory, 10), 0)
      .toString();

    api
      .post('flow/send-muhaberat-notification-mail', {
        email: emailTo,
        date: formattedDate,
        inventoryCount,
        pdfLink,
        excelLink,
      })
      .then((res) => {})
      .catch((err) => {
        console.error('Mail gönderme hatası:', err);
      });
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedCargoStatus(
      typeof value === 'string' ? value.split(',') : value
    );
  };

  const handleChangeFilterBranch = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedBranches(value);
  };

  const handleCheckboxChange = (event, id, object) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [...selected];
    let newSelectedItems = [...selectedItems];
    if (selectedIndex === -1) {
      newSelected.push(id);
      newSelectedItems.push(object);
    } else {
      newSelected.splice(selectedIndex, 1);
      const itemIndex = newSelectedItems.findIndex((item) => item.id === id);
      newSelectedItems.splice(itemIndex, 1);
    }
    setSelected(newSelected);
    setSelectedItems(newSelectedItems);
  };

  const selectAll = () => {
    const pageStartIndex = page * rowsPerPage;
    const pageEndIndex = pageStartIndex + rowsPerPage;

    const selectedItems = orderList
      // .slice(pageStartIndex, pageEndIndex)
      .filter((row) => row.status === '5')
      .map((row) => row);

    const selectedIds = orderList
      // .slice(pageStartIndex, pageEndIndex)
      .filter((row) => row.status === '5')
      .map((row) => row.id);

    setSelectedItems(selectedItems);
    setSelected(selectedIds);
    // setSelectedItems(selectedIds);
  };

  function exportToExcel(list, data, returnLink = false) {
    let temp1 = list?.map((x, index) => {
      const matchedData = data?.find((item) => item.id === x.id);
      let a = {
        id: index + 1,
        customer: x.dataJSON.customerName || '',
        barcode: x.barcode || '',
        tower: x.dataJSON.tower || '',
        office: x.dataJSON.office || '',
        willTakenBy: recieverNameLastname || '',
        lobbyDelivery: '',
        amount: x.orderInventory || '',
        shipmentFirm: x.dataJSON.shipmentFirm || '',
        takenBy: returnLink
          ? recieverNameLastname
          : x.status !== '5'
          ? x.handover?.name + ' ' + x.handover?.lastname
          : '-',
        deliveredDate: returnLink
          ? deliveryTimestamp.format('DD.MM.YYYY')
          : x.deliveredDateTime
          ? moment.unix(x.deliveredDateTime).format('DD/MM/YYYY')
          : '-',
        deliveredTime: returnLink
          ? deliveryTimestamp.format('HH:mm')
          : x.deliveredDateTime
          ? moment.unix(x.deliveredDateTime).format('HH:mm')
          : '-',
        status: returnLink
          ? 'Teslim Edildi'
          : x.status === '5'
          ? 'Şubede'
          : 'Teslim Edildi',
      };
      if (matchedData) {
        a.customer = matchedData.customerName || a.customer;
        a.barcode = matchedData.barcode || a.barcode;
        a.amount = matchedData.orderInventory || a.amount;
        a.shipmentFirm = matchedData.shipmentFirm || a.shipmentFirm;
        a.tower = matchedData.tower || a.tower;
        a.office = matchedData.office || a.office;
        a.takenBy = matchedData.handover
          ? matchedData.handover.name + ' ' + matchedData.handover.lastname
          : a.takenBy;
        a.lobbyDelivery = matchedData.lobbyDelivery || a.lobbyDelivery;
        (a.willTakenBy = matchedData.willTakenBy || a.willTakenBy),
          (a.deliveredDate = matchedData.deliveredDateTime
            ? moment.unix(matchedData.deliveredDateTime).format('DD/MM/YYYY')
            : a.deliveredDate);
        a.deliveredTime = matchedData.deliveredDateTime
          ? moment.unix(matchedData.deliveredDateTime).format('HH:mm')
          : a.deliveredTime;
        a.status = returnLink
          ? 'Teslim Edildi'
          : matchedData.status === '5'
          ? 'Şubede'
          : 'Teslim Edildi';
      }
      return a;
    });

    const payload = {
      type: 'excel',
      content: temp1,
      header: {
        NO: 'number',
        'İSİM SOYİSİM': 'string',
        BARKOD: 'string',
        KULE: 'string',
        DAİRE: 'string',
        'TESLİM ALAN': 'string',
        'LOBİ TESLİMATI': 'string',
        MİKTAR: 'string',
        'KARGO İSMİ': 'string',
        'TESLİM ALAN KİŞİ': 'string',
        'TESLİM TARİHİ': 'string',
        'TESLİM SAATİ': 'string',
        DURUM: 'string',
      },
      sheetTitle: 'İşler',
    };

    if (returnLink) {
      return api.post('excel/export', payload).then((response) => {
        if (response.data.status) {
          return response.data.result;
        }
        throw new Error('Excel export başarısız');
      });
    }

    api
      .post('excel/export', payload)
      .then((response) => {
        if (response.data.status) {
          try {
            const newWindow = window.open(response.data.result, '_blank');
            if (
              !newWindow ||
              newWindow.closed ||
              typeof newWindow.closed === 'undefined'
            ) {
              setShowPopUpError(true);
              throw new Error('Pop-up engellendi. Lütfen izin verin.');
            }
          } catch (e) {
            setShowPopUpError(true);
          }
        } else {
          toast.error("EXCEL'e aktarılırken bir hata meydana geldi.");
        }
      })
      .catch(() => {
        toast.error("EXCEL'e aktarılırken bir hata meydana geldi.");
      });
  }

  function createPDF(selectedItems, returnLink = false) {
    const body = selectedItems.map((item, i) => [
      { text: i + 1, alignment: 'center' },
      { text: item.dataJSON.customerName || '-', alignment: 'left' },
      { text: item.barcode || '-', alignment: 'left' },
      {
        text: deliveryTimestamp.format('DD.MM.YYYY HH:mm'),
        alignment: 'center',
      },
      {
        // text: item.handover
        //   ? `${item.handover.name} ${item.handover.lastname}`
        //   : '-',
        text: recieverNameLastname,
        alignment: 'left',
      },
      { text: item.orderInventory || '-', alignment: 'center' },
      { text: item.dataJSON.shipmentFirm || '-', alignment: 'left' },
    ]);

    // Tarih metnini parçalı oluşturuyoruz
    const today = moment().format('DD.MM.YYYY');
    const [dayMonth, year] = today.split('.').reduce(
      (acc, part, idx) => {
        if (idx < 2) acc[0].push(part);
        else acc[1] = part;
        return acc;
      },
      [[], '']
    );
    const dayMonthText = dayMonth.join('.');
    const yearText = `.${year}`;

    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      content: [
        // Logo (sol üst) ve tarih (sağ üst)
        {
          columns: [
            { image: logoBase64, width: 80, margin: [0, 0, 0, 0] },
            {
              text: [{ text: dayMonthText, bold: true }, { text: yearText }],
              color: '#374151',
              alignment: 'right',
              margin: [0, 0, 0, 0],
            },
          ],
          columnGap: 0,
          margin: [0, 0, 0, 20],
        },

        // Tek satırda başlık
        {
          text: [
            {
              text: 'MALL LOGISTICS ',
              fontWeight: 300,
              fontSize: 14,
              bold: false,
              characterSpacing: 1.4,
              lineHeight: 1,
              alignment: 'center',
              color: '#000',
            },
            {
              text: 'ZORLU CENTER OFİS',
              fontWeight: 600,
              fontSize: 14,
              bold: true,
              characterSpacing: 3.6,
              lineHeight: 1.5,
              alignment: 'center',
              color: '#000',
            },
          ],
          margin: [0, 0, 0, 12],
        },

        // Tablo
        {
          table: {
            headerRows: 1,
            widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: [
              [
                { text: 'NO', style: 'tableHeader' },
                { text: 'İSİM SOYİSİM', style: 'tableHeader' },
                { text: 'BARKOD NO', style: 'tableHeader' },
                { text: 'ZİMMET TARİHİ', style: 'tableHeader' },
                { text: 'ZİMMETE ALAN', style: 'tableHeader' },
                { text: 'MİKTAR', style: 'tableHeader' },
                { text: 'KARGO FİRMASI', style: 'tableHeader' },
              ],
              ...body,
            ],
          },
          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? '#F5F5F5' : null),
            hLineColor: () => '#EEEEEE',
            vLineColor: () => '#EEEEEE',
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            paddingLeft: () => 6,
            paddingRight: () => 6,
            paddingTop: () => 4,
            paddingBottom: () => 4,
          },
        },
      ],
      styles: {
        tableHeader: {
          fontSize: 9,
          bold: false,
          color: '#6B7280',
          alignment: 'center',
        },
      },
      defaultStyle: {
        fontSize: 10,
      },
    };

    if (returnLink) {
      return new Promise((resolve) => {
        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        pdfDocGenerator.getBase64((data) => {
          api
            .post('flow/save-pdf', {
              content: data,
            })
            .then((res) => {
              if (res.data.status) {
                resolve(res.data.result);
              } else {
              }
            })
            .catch((err) => console.log(err));
        });
      });
    } else {
      pdfMake.createPdf(docDefinition).open();
    }
  }

  const firstInputRef = useRef(null);

  useEffect(() => {
    const handleCopy = (event) => {
      const selectedText = window.getSelection().toString();
      const trimmedText = selectedText.trim();
      event.clipboardData.setData('text/plain', trimmedText);
      event.preventDefault();
    };

    document.addEventListener('copy', handleCopy);

    return () => {
      document.removeEventListener('copy', handleCopy);
    };
  }, []);

  useEffect(() => {
    if (filterModal) {
      setTimeout(() => {
        firstInputRef.current.focus();
      }, 100);
    }
  }, [filterModal]);

  function objectsToTable(objectArray) {
    if (objectArray.length === 0) return []; // Eğer dizi boşsa boş bir tablo döndür

    // Objelerin tüm özelliklerini alarak sütun başlıklarını oluştur
    const columnHeaders = Object.keys(objectArray[0]);

    // Tablo başlığı (sütun başlıkları)
    const table = [columnHeaders];

    // Her objeyi döngü ile işle ve tabloya ekle
    objectArray.forEach((obj) => {
      const row = columnHeaders.map((header) => obj[header]);
      table.push(row);
    });

    return table;
  }

  const getData = () => {
    if (customer?.customer?.id) {
      api
        .post('flow/concierge-get-users', {
          metaTags: ['Zorlu Center'],
        })
        .then((response) => {
          if (response.data.status) {
            setPersonelList(response.data.result);
          } else {
            setPersonelList([]);
          }
        })
        .catch((error) => {
          console.log(error);
          setPersonelList([]);
        });

      api
        .post('posts/get', {
          type: 'post-office',
          mallID: customer?.customer?.id,
          status: StatusList.filter((x) => x.id != 0).map((x) => x.id),
          limit: 2000,
          direction: ['CustomerToMallLogistics', 'MallLogisticsToCustomer'],
        })
        .then((response) => {
          if (response.data.status) {
            const data = response.data.result;
            //*The lands of Tema Park */            /*Zorlu Center*/          /*Akyaka Park AVM */
            //"MallLogisticsToStore"                //1                       //"MallLogisticsToStore"
            //"StoreToMallLogistics"

            /*Forum Aydın Avm */ /* Type "corporational-accept-goods"*/
            //"MallLogisticsToStore"
            const uniqueBranches = Array.from(
              new Map(data.map((item) => [item.branchTitle, item.to.branchID]))
            ).map(([branchTitle, branchID]) => ({ branchTitle, branchID }));

            setBranchTitles(uniqueBranches);
            setOriginalData(data);
            setOrderList(data);
          } else {
            console.log('error', response);
            toast.error('Veri bulunamadı.');
            setOriginalData([]);
            setOrderList([]);
          }
        })
        .catch(() => {
          toast.error('Veriler çekilemedi, bağlantınızı kontrol ediniz.');
          setOriginalData([]);
          setOrderList([]);
        });
    }
  };

  const getDataForExcel = (list) => {
    api
      .post('flow/concierge-get-users', {
        metaTags: ['Zorlu Center'],
      })
      .then((response) => {
        if (response.data.status) {
          setPersonelList(response.data.result);
        } else {
          setPersonelList([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setPersonelList([]);
      });

    api
      .post('posts/get', {
        type: 'post-office',
        mallID: customer?.customer?.id,
        status: StatusList.filter((x) => x.id != 0).map((x) => x.id),
        limit: 20000,
      })
      .then((response) => {
        if (response.data.status) {
          const data = response.data.result.filter(
            (item) =>
              item.dataJSON.direction === 'MallLogisticsToCustomer' ||
              item.dataJSON.direction === 'CustomerToMallLogistics'
          );

          exportToExcel(list, data);
        } else {
          toast.error('Veri bulunamadı.');
          setOriginalData([]);
          setOrderList([]);
        }
      })
      .catch(() => {
        toast.error('Veriler çekilemedi, bağlantınızı kontrol ediniz.');
        setOriginalData([]);
        setOrderList([]);
      });
  };

  useEffect(() => {
    getData();
  }, [customer]);

  const handleOpenAddPersonelModal = () => {
    setAddPersonelModalOpen(true);
    setIsModalEdit(false);
  };

  const handleOpenDeliveryModal = (id, object) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [...selected];
    let newSelectedItems = [...selectedItems];
    if (selectedIndex === -1) {
      newSelected.push(id);
      newSelectedItems.push(object);
    } else {
      newSelected.splice(selectedIndex, 1);
      const itemIndex = newSelectedItems.findIndex((item) => item.id === id);
      newSelectedItems.splice(itemIndex, 1);
    }

    setSelected(newSelected);
    setSelectedItems(newSelectedItems);
    setHandoverModal(true);
  };

  const handleCloseDeliveryModal = () => {
    setSelected([]);
    setSelectedItems([]);
    setHandoverModal(false);
  };

  const handleBack = () => {
    setSelectedOrder(null);
  };

  const completeDeliver = (code) => {
    setIsBackdropOpen(true);
    const selectedObjects = selected.map((item) => ({
      postID: item,
      status: 1,
    }));

    if (code === confirmCode && selectedObjects.length > 0) {
      api.post('posts/change-status', selectedObjects).then((response) => {
        if (response.data.status) {
          setIsBackdropOpen(false);
          setHandoverModal(false);
          getFilteredOrderList();
          setSuccessModalOpen(true);

          Promise.all([
            createPDF(selectedItems, true),
            exportToExcel(selectedItems, orderList, true),
          ]).then(([pdfLink, excelLink]) => {
            // Burada tower kontrolü yapıyoruz
            let emailTo;
            for (const item of selectedItems) {
              const tower = item.dataJSON?.tower;
              if (tower && tower.length > 1 && emailsMap[tower]) {
                emailTo = emailsMap[tower];
                break;
              }
            }
            // eğer emailTo undefined ise sendMail içinde hiçbir şey yapmaz
            sendMail(selectedItems, pdfLink, excelLink, emailTo);
          });
        } else {
          setIsBackdropOpen(false);
        }
      });
    } else {
      setIsBackdropOpen(false);
      toast.error('Doğrulama kodu hatalıdır. Lütfen tekrar deneyin.');
    }
  };

  const handleDeliver = (name, lastname, phone, note) => {
    const ts = moment();
    setDeliveryTimestamp(ts);
    const fullName = `${name} ${lastname}`;
    setRecieverNameLastname(fullName);
    let totalPackageCount = 0;
    for (let i = 0; i < selectedItems.length; i++) {
      totalPackageCount += Number(selectedItems[i].orderInventory);
    }
    setTotalPackageCount(totalPackageCount);
    api
      .post('handover/malllogistics/create', {
        postID: selected,
        message: `${selected?.length} adet gönderiyi (${totalPackageCount} paket) teslim alabilmeniz için {code} kodunu yetkiliye veriniz`,
        name: name,
        lastname: lastname,
        phone: phone,
        note: note,
        sentHandoverMail: true,
      })
      .then((response) => {
        if (response.data.status) {
          setConfirmCode(response.data.result.code);
        } else {
          toast.error(
            'Bir hata oluştu, lütfen pencereyi kapatıp gönderiyi yeniden seçerek işlemi tekrar ediniz. Bir hata olduğunu düşünüyorsanız teknik destek ile iletişime geçebilirsiniz.'
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Helmet>
        <title> Muhaberat Çıkış | Mall Logistics Panel </title>
      </Helmet>

      <Stack style={{ paddingInline: '25px' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Muhaberat Çıkış
          </Typography>
          {['store:manageroperations', 'store:operations'].includes(
            tokenService.getUser()?.accountCategory +
              ':' +
              tokenService
                .getUser()
                ?.frontAuth?.map((x) => x)
                .join('')
          ) && (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => setOpenCreateModal(true)}
            >
              İş Emri Oluştur
            </Button>
          )}
          <Stack
            direction={isMobile ? 'column' : 'row'}
            alignItems="end"
            justifyContent="flex-start"
            paddingY={2}
            paddingX={1}
            spacing={2}
          >
            {showAddPersonelModal ? (
              <>
                {parsedUser.type !== 'user' && (
                  <>
                    <Button
                      sx={{
                        marginInline: '8px',
                        fontSize: 14,
                        fontFamily: 'Inter',
                        fontWeight: 400,
                        letterSpacing: 0.4,
                        height: 40,
                        borderRadius: '5px',
                        padding: '8px 16px 8px 16px',
                        gap: '6px',
                      }}
                      variant="contained"
                      color="primary"
                      component={Link}
                      to="/dashboard/muhaberat-output-users"
                    >
                      KULE ÇALIŞANI LİSTESİ
                    </Button>
                    <AddEntityButton
                      label={'Kule Çalışanı Ekle'}
                      onClick={() => handleOpenAddPersonelModal()}
                    />
                  </>
                )}
              </>
            ) : null}
            <ExportToExcelButton
              setShowPopUpError={setShowPopUpError}
              showPopUpError={showPopUpError}
              onClick={() => exportToExcel(orderList)}
              sx={{ marginLeft: '7px' }}
            />
          </Stack>
        </Stack>

        <Stack
          direction="row"
          justifyContent={isMobile ? 'space-between' : 'end'}
          mb={5}
        >
          {isMobile ? (
            <FilterViewButton variant="contained" onClick={handleModal} />
          ) : null}
        </Stack>
        <Card>
          <CustomFilter
            modalType={'drawer'}
            filterModal={filterModal}
            handleCloseModal={handleCloseModal}
          >
            {/* Filtreleme Satırı 1 */}
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="flex-start"
              spacing={2}
              padding={2}
              mb={2}
            >
              <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                <TextField
                  label="Barkod"
                  inputRef={firstInputRef}
                  variant="outlined"
                  value={barcode}
                  onChange={(e) => setBarcode(e.target.value.trim())}
                  error={barcode.length > 0 && barcode.length < 5}
                  helperText={
                    barcode.length > 0 && barcode.length < 5
                      ? 'En az 5 karakter giriniz'
                      : ''
                  }
                  inputProps={{
                    minLength: 5, // HTML5 özelliği
                  }}
                  sx={{ flex: 1 }}
                />
              </FormControl>

              <FormControl sx={{ flex: 1, minWidth: '100%', maxWidth: '100%' }}>
                <Select
                  multiple
                  displayEmpty
                  value={selectedBranches}
                  onChange={handleChangeFilterBranch}
                  input={<OutlinedInput />}
                  renderValue={(selected) => {
                    if (!selected || selected.length === 0) {
                      return <em>Firma</em>;
                    }

                    return selected
                      .map(
                        (id) =>
                          branchTitles.find((branch) => branch.branchID === id)
                            ?.branchTitle || id
                      )
                      .join(', ');
                  }}
                  MenuProps={MenuProps}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {branchTitles.map((x) => (
                    <MenuItem key={x.branchID} value={`${x.branchID}`}>
                      {x.branchTitle}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                <TextField
                  label="Kargo Firması"
                  variant="outlined"
                  value={cargo}
                  onChange={(e) => setCargo(e.target.value)}
                  sx={{ flex: 1 }}
                />
              </FormControl>
              <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                <TextField
                  label="Kule"
                  variant="outlined"
                  value={tower}
                  onChange={(e) => setTower(e.target.value)}
                  sx={{ flex: 1 }}
                />
              </FormControl>
              <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                <TextField
                  label="Daire"
                  variant="outlined"
                  value={office}
                  onChange={(e) => setOffice(e.target.value)}
                  sx={{ flex: 1 }}
                />
              </FormControl>

              <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                <TextField
                  label="Teslim Alan kişi"
                  variant="outlined"
                  value={deliveredName}
                  onChange={(e) => setDeliveredName(e.target.value)}
                  sx={{ flex: 1 }}
                />
              </FormControl>
            </Stack>

            {/* Filtreleme Satırı 2 */}

            <Stack
              direction="column"
              alignItems="center"
              justifyContent="flex-start"
              spacing={2}
              paddingX={2}
              mb={2}
            >
              <Stack direction="row" spacing={1}>
                <FormControl sx={{ flex: 1, minWidth: '49%' }}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="Başlangıç Tarihi"
                      value={startDate}
                      onChange={(newValue) => setStartDate(newValue)}
                      sx={{ flex: 1 }}
                    />
                  </LocalizationProvider>
                </FormControl>
                <FormControl sx={{ flex: 1, minWidth: '49%' }}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="Bitiş Tarihi"
                      value={endDate}
                      onChange={(newValue) => setEndDate(newValue)}
                      sx={{ flex: 1 }}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Stack>

              <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                <Select
                  multiple
                  displayEmpty
                  value={selectedCargoStatus}
                  onChange={handleChange}
                  input={<OutlinedInput />}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <em>Kargo Durumu</em>;
                    }

                    return selected.map((x) => x?.label).join(', ');
                  }}
                  MenuProps={MenuProps}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {StatusList.map((x) => (
                    <MenuItem key={x.id} value={x}>
                      {x.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
            <Stack
              direction="column"
              justifyContent="flex-start"
              spacing={2}
              paddingX={2}
              mb={2}
            >
              <Stack direction="row" gap={2}>
                <FormControl sx={{ flex: 1, minWidth: '75%' }}>
                  <TextField
                    label="Kişi"
                    variant="outlined"
                    value={filterName}
                    onChange={(e) => setFilterName(e.target.value)}
                    sx={{ flex: 1 }}
                  />
                </FormControl>
                <FormControl sx={{ flex: 1, minWidth: '25%' }}>
                  <FormControlLabel
                    sx={{ flex: 1 }}
                    control={
                      <Checkbox
                        checked={customerNameLike}
                        onChange={handleChangeCustomerNameLike}
                      />
                    }
                    label="İçeren"
                  />
                </FormControl>
              </Stack>
            </Stack>

            {/* Divider */}
            <Divider sx={{ width: '100%', mb: 2 }} />

            {/* Butonlar */}
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              mb={2}
              paddingX={2}
            >
              <Stack direction="row" spacing={2}>
                <ClearButton onClick={clearFilters} />
                <FilterButton onClick={getFilteredOrderList} />
              </Stack>
            </Stack>
          </CustomFilter>

          <DynamicTable
            data={orderList}
            headers={TABLE_HEAD}
            initialOrder={'createdDateTime'}
            initalOrderDirection={'desc'}
            isOrdered={false}
            handleCheckboxChange={handleCheckboxChange}
            selected={selected}
            isMobile={isMobile}
            handleModal={handleModal}
            handleCloseModal={handleCloseModal}
            resetPage={resetPage}
            // rowOnClick={(row) => handleOpenDeliveryModal(row.id, row)}
          >
            {parsedUser.type !== 'user' && (
              <Stack direction="row" spacing={2}>
                <Button variant="contained" color="primary" onClick={selectAll}>
                  Hepsini Seç
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setSelected([]);
                    setSelectedItems([]);
                  }}
                >
                  Hepsini Kaldır
                </Button>
              </Stack>
            )}
          </DynamicTable>
        </Card>
      </Stack>

      {addPersonelModalOpen && (
        <AddEditPersonelModal
          open={addPersonelModalOpen}
          onClose={() => setAddPersonelModalOpen(false)}
          isEdit={isModalEdit}
        />
      )}

      {openCreateModal && (
        <CreateWorkOrderModal
          openCreateModal={openCreateModal}
          onCreateModal={() => setOpenCreateModal(false)}
          customer={customer}
          locations={locations}
        />
      )}

      {handoverModal && (
        <DeliveryModal
          open={handoverModal}
          count={selectedItems?.length}
          onClose={handleCloseDeliveryModal}
          onBack={handleBack}
          onDeliver={handleDeliver}
          onComplete={completeDeliver}
          selectedItems={selectedItems}
          onAddPersonel={() => {
            setSelected([]);
            setSelectedItems([]);
            setHandoverModal(false);
            handleOpenAddPersonelModal();
          }}
          isLoading={isBackdropOpen}
          packageCount={totalPackageCount}
        />
      )}

      {selected?.length > 0 && (
        <Box className="bottom-center-container">
          <Button
            variant="contained"
            color="primary"
            className="bottom-center-button"
            onClick={() => setHandoverModal(true)}
          >
            ({selected?.length}) Teslim Et
          </Button>
        </Box>
      )}

      {editModalOpen && (
        <EditMuhaberatOutputPost
          post={selectedPost}
          onClose={handleCloseEditModal} // Modalı kapatmak için fonksiyon gönder
        />
      )}

      <Modal
        open={isSuccessModalOpen}
        onClose={() => {
          setSuccessModalOpen(false);
          window.location.reload();
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            width: 700,
            height: 350,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <CheckCircleIcon sx={{ color: 'green', fontSize: 64 }} />
          <Typography variant="h6">
            {selected?.length} adet gönderi başarıyla teslim edildi.
          </Typography>
          <Typography>
            Aşağıdaki seçenekler ile seçiminizi, Excel veya PDF formatında
            indirebilirsiniz.
          </Typography>
          <Tooltip title="Dosya indirme hakkında bilgi için tıklayın">
            <IconButton
              size="small"
              sx={{
                color: 'gray',
                marginLeft: '8px',
                animation: 'pulse 2s infinite',
                '@keyframes pulse': {
                  '0%': {
                    transform: 'scale(1)',
                    color: 'gray',
                  },
                  '50%': {
                    transform: 'scale(1.1)',
                    color: '#088AB2', // Açık mavi
                  },
                  '100%': {
                    transform: 'scale(1)',
                    color: 'gray',
                  },
                },
              }}
              onClick={handleOpen}
            >
              <HelpOutlineIcon />
            </IconButton>
          </Tooltip>

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 800,
                bgcolor: 'background.paper',
                borderRadius: '10px',
                boxShadow: 24,
                p: 4,
                justifyContent: 'flex-end',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <h3 id="modal-title">Dosya İndirme Uyarısı</h3>
              <img
                src={require('../../src/assets/images/popUpError.png')}
                alt="Pop-up Error"
                style={{
                  display: 'block',
                  margin: '20px auto',
                  maxWidth: '100%',
                  height: 'auto',
                }}
              />
              <p id="modal-description">
                Eğer tarayıcınızda görseldeki işareti görüyorsanız, gösterilen
                ikona tıklayarak tarayıcınızdan, bu sayfa için{' '}
                <b>"Pop-up'lar ve yönlendirmeler"</b> seçeneğine izin vermeniz
                gerekmektedir. Aksi durumda dosya indirme işlemlerinize engel
                olacaktır.
              </p>
              <Button onClick={handleClose} variant="contained" color="primary">
                Tamam
              </Button>
            </Box>
          </Modal>
          <Button
            sx={{
              width: 500,
            }}
            variant="contained"
            color="info"
            onClick={() => createPDF(selectedItems)}
          >
            PDF'e Aktar
          </Button>
          <Button
            sx={{
              width: 500,
            }}
            variant="contained"
            color="info"
            onClick={() => getDataForExcel(selectedItems)}
            disabled={!isOnline} // Disable if offline
          >
            {isOnline
              ? 'Excele Aktar'
              : "Excel'e aktar (İnternet bağlantısı gerekmektedir.)"}
          </Button>
          <Button
            sx={{
              width: 500,
            }}
            onClick={() => {
              setSuccessModalOpen(false);
              window.location.reload();
            }}
          >
            Tamam
          </Button>
        </Box>
      </Modal>
    </>
  );
}
